export default "__VITE_ASSET__H3o_Z5CR__"